// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1nSwX","detailsBorder":"styles_detailsBorder__3MKDE"};